import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0 8px 24px 8px;

  .ant-divider {
    margin: 0;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    padding: 0 16px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.lg}) {
    padding: 0;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  justify-content: space-between;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SectionWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black6};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const ActivityDescriptionWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const NameWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;

export const CourseWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
